"use client";

import type { FontOption } from "./data";

export function FontCard({
  font,
  isSelected,
  onSelect,
  isLoaded,
}: {
  font: FontOption;
  isSelected: boolean;
  onSelect: (f: FontOption) => void;
  isLoaded: boolean;
}) {
  return (
    <button
      onClick={() => onSelect(font)}
      className="group w-full rounded-xl border p-3 text-left transition-all duration-200"
      style={{
        borderColor: isSelected
          ? "rgba(30,63,232,0.6)"
          : "rgba(245,245,247,0.08)",
        background: isSelected
          ? "rgba(30,63,232,0.08)"
          : "rgba(255,255,255,0.02)",
      }}
    >
      <p
        className="mb-1 text-xl font-bold leading-tight"
        style={{
          fontFamily: isLoaded ? `"${font.name}", sans-serif` : "inherit",
          color: isSelected ? "#3B7EFF" : "#F5F5F7",
        }}
      >
        Aa
      </p>
      <p className="text-xs font-medium" style={{ color: "#C7C7CE" }}>
        {font.name}
      </p>
    </button>
  );
}
